import { callAPI } from 'Shared/helpers'

export const ActionTypes = {
  FETCH_INITIAL_DATA_REQUEST: 'FETCH_INITIAL_DATA_REQUEST',
  FETCH_INITIAL_DATA_RECEIVED: 'FETCH_INITIAL_DATA_RECEIVED',
  SET_MONTH: 'SET_MONTH',
  SET_STATISTICS: 'SET_STATISTICS',
  SET_PUBLIC_HOLIDAYS: 'SET_PUBLIC_HOLIDAYS',
}

export const fetchInitialData = () => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.FETCH_INITIAL_DATA_REQUEST,
  })

  const state = getState()
  const dataURL = state.misc.fetchInitialDataURL
  callAPI(dataURL, 'GET')
  .then(response => {
    dispatch({
      type: ActionTypes.FETCH_INITIAL_DATA_RECEIVED,
      data: response,
    })
  })
  .catch(() => {
    console.error('Error while fetching accounting data!')
  })
}

export const setPublicHolidaysInStore = publicHolidays => {
  return {
    type: ActionTypes.SET_PUBLIC_HOLIDAYS,
    public_holidays: publicHolidays,
  }
}
